import React, { Component } from "react";
import { Bar, Line } from "react-chartjs-2";
import { CardColumns, Card, CardHeader, CardBody } from "reactstrap";
import { List } from "react-content-loader";
import AuthService from "../../../components/AuthService";
const MyListLoader = () => <List />;

class ChartsMoodRessenti extends Component {
  constructor() {
    super();
    this.Auth = new AuthService();
    this.state = {
      fetchInProgress: {
        moodByDay: true
      },
      data: {
        moodByDay: {}
      }
    };
  }

  getColors(lvlCount) {
    let colors = [lvlCount];
    let borderColors = [lvlCount];
    let r,
      g,
      b = 0;
    for (let i = 0; i < lvlCount; i++) {
      r = Math.floor(Math.random() * 256);
      g = Math.floor(Math.random() * 256);
      b = Math.floor(Math.random() * 256);
      colors[i] = "rgba(" + r + "," + g + "," + b + ", 0.4)";
      borderColors[i] = "rgba(" + r + "," + g + "," + b + ", 1)";
    }
    return { colors: colors, borderColors: borderColors };
  }


  barChartData(thus, dataType) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/" + dataType + this.props.request
    ).then(function(datas) {
      let labelCustom = [],
        dataCustom = [];
      Object.keys(datas.data).forEach(function(key) {
        labelCustom.push(datas.data[key].label);
        dataCustom.push(datas.data[key].data);
      });

      let dataSetsCustom = [
        {
          label: "",
          backgroundColor: "rgba(90,61,145,0.2)",
          borderColor: "rgba(90,61,145,1)",
          borderWidth: 1,
          hoverBackgroundColor: "rgba(90,61,145,0.4)",
          hoverBorderColor: "rgba(90,61,145,1)",
          minBarLength: 3, // taille pour les bar = 0
          data: dataCustom
        }
      ];

      thus.setState(function(state, props) {
        let fetch = state.fetchInProgress;
        let data = state.data;
        switch (dataType) {
          case "moodByDay":
            fetch.moodByDay = false;
            data.moodByDay = {
              labels: labelCustom,
              datasets: dataSetsCustom
            };
            break;
        }
        return {
          fetchInProgress: fetch,
          data: data
        };
      });
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  fetchAllData() {
    this.barChartData(this, "moodByDay");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchAllData();
    }
  }

  componentDidMount() {
    this.fetchAllData();
  }

  render() {
    let contentBarMoodByDay;

    if (this.state.fetchInProgress.moodByDay) {
      contentBarMoodByDay = <List />;
    } else {
      contentBarMoodByDay = (
        <div className="chart-wrapper">
          <Bar
            data={this.state.data.moodByDay}
            options={{
              maintainAspectRatio: 0,
              responsive: !0,

              scales: {
                xAxes: [
                  {
                    gridLines: { display: !0 },
                    scaleLabel: { display: !0, labelString: "Date" },
                    ticks: {
                      beginAtZero: true,
                      maxTicksLimit: 10,
                      padding: 25,

                    }
                  }
                ],
                yAxes: [
                  {
                    gridLines: { display: true },
                    scaleLabel: { display: true, labelString: "Météo moyenne" },
                    ticks: {
                      beginAtZero:true,
                      maxTicksLimit: 10,
                      padding: 25,
                      max:10,
                      min:0,
                      suggestedMin: 0, //min
                      suggestedMax: 100, //max

                    }
                  }
                ]
              },
              scaleBeginAtZero : true
            }}
          />
        </div>
      );
    }



    return (
      <React.Fragment>
        <Card>
            <CardHeader>
              Météo moyenne par jour
              <div className="card-actions" />
            </CardHeader>
            <CardBody>{contentBarMoodByDay}</CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default ChartsMoodRessenti;



// WEBPACK FOOTER //
// ./src/views/Base/ChartsMoodRessenti/ChartsMoodRessenti.js